import {
  literalParamWithDefault,
  optionalStringParam,
  parseableSearchSchema,
} from "@crm/effect/schema/search";
import { Schema } from "effect";

export const groupDetailSearchSchema = parseableSearchSchema(
  Schema.Struct({
    tab: literalParamWithDefault(["members", "feedback", "tasks", "media"], "members"),
    mediaType: optionalStringParam(),
    mediaTag: optionalStringParam(),
    feedbackDay: optionalStringParam(),
  }),
);

export type GroupDetailSearch = Schema.Schema.Type<typeof groupDetailSearchSchema>;
